import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { DocumentsPublicType } from '../../pages/EditDocumentCategoryPage/types';
import { routerPath } from '../../router/routerPath';
import { NavbarLayout } from '../NavbarComponent/styled';
import { DocumentsNavbarContainer } from './styled';

type DocumentsNavigationComponentProps = {
  documents: DocumentsPublicType;
  closeNav: () => void;
};

export const DocumentsNavigationComponent: FC<DocumentsNavigationComponentProps> = ({ closeNav, documents }) => {
  return (
    <DocumentsNavbarContainer>
      <div className="layout">
        {documents &&
          documents.length > 0 &&
          documents.map((el) => (
            <NavbarLayout onClick={() => closeNav()} justify="flex-start" key={el.id}>
              <Link to={`${routerPath.document}${el.id}`}>{el.title}</Link>
            </NavbarLayout>
          ))}
      </div>
    </DocumentsNavbarContainer>
  );
};
